import { Navigate, Route, Routes } from "react-router-dom";

import { AppLayout } from "./components/layout/AppLayout";
import { StaffGate } from "./components/StaffGate";
import { Login } from "./pages/Login";
import { StaffOnboarding } from "./pages/StaffOnboarding";
import { Dashboard } from "./pages/Dashboard";
import { Passkeys } from "./pages/Passkeys";
import { ServiceKeysList } from "./pages/ServiceKeysList";
import { ServiceKeyCreate } from "./pages/ServiceKeyCreate";
import { ServiceKeyValidate } from "./pages/ServiceKeyValidate";
import { UserGrant } from "./pages/UserGrant";
import { UserSearch } from "./pages/UserSearch";
import { Invitations } from "./pages/Invitations";
import { Roles } from "./pages/Roles";
import { PermissionsPage } from "./pages/PermissionsPage";
import { DiscordTracker } from "./pages/DiscordTracker";
import { SupportDashboard } from "./pages/SupportDashboard";
import { AuditLogsPage } from "./pages/AuditLogsPage";
import { NotificationsPage } from "./pages/NotificationsPage";
import { PermissionGate } from "./rbac/PermissionGate";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/staff/onboarding" element={<StaffOnboarding />} />
      <Route
        path="/"
        element={
          <StaffGate>
            <AppLayout />
          </StaffGate>
        }
      >
        <Route index element={<Dashboard />} />
        <Route
          path="passkeys"
          element={
            <PermissionGate permission="passkeys.view">
              <Passkeys />
            </PermissionGate>
          }
        />
        <Route
          path="service-keys"
          element={
            <PermissionGate permission="service_keys.view">
              <ServiceKeysList />
            </PermissionGate>
          }
        />
        <Route
          path="service-keys/new"
          element={
            <PermissionGate permission="service_keys.create">
              <ServiceKeyCreate />
            </PermissionGate>
          }
        />
        <Route
          path="service-keys/:id/runs/:runId"
          element={
            <PermissionGate permission="service_keys.validate">
              <ServiceKeyValidate />
            </PermissionGate>
          }
        />
        <Route
          path="users"
          element={
            <PermissionGate permission="users.view">
              <UserSearch />
            </PermissionGate>
          }
        />
        <Route
          path="users/grant"
          element={
            <PermissionGate permission="users.grant">
              <UserGrant />
            </PermissionGate>
          }
        />
        <Route
          path="invitations"
          element={
            <PermissionGate permission="invitations.view">
              <Invitations />
            </PermissionGate>
          }
        />
        <Route
          path="notifications"
          element={
            <PermissionGate roles={["developer", "admin"]}>
              <NotificationsPage />
            </PermissionGate>
          }
        />
        <Route
          path="roles"
          element={
            <PermissionGate permission="roles.view">
              <Roles />
            </PermissionGate>
          }
        />
        <Route
          path="permissions"
          element={
            <PermissionGate permission="roles.view">
              <PermissionsPage />
            </PermissionGate>
          }
        />
        <Route
          path="discord"
          element={
            <PermissionGate permission="discord.view">
              <DiscordTracker />
            </PermissionGate>
          }
        />
        <Route
          path="support"
          element={<SupportDashboard />}
        />
        <Route
          path="audit-logs"
          element={
            <PermissionGate role="developer">
              <AuditLogsPage />
            </PermissionGate>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
